<template>
  <TemplateForm />
</template>


<script>
import TemplateForm from '@/components/template/TemplateForm.vue';

export default {
  components: {
    TemplateForm,
  },
}
</script>

<style lang="scss" scoped></style>